__turbopack_context__.v({
  "accent": "theme-module__4jKnka__accent",
  "backdrop": "theme-module__4jKnka__backdrop",
  "berry-moderate": "theme-module__4jKnka__berry-moderate",
  "berry-standard": "theme-module__4jKnka__berry-standard",
  "berry-strong": "theme-module__4jKnka__berry-strong",
  "berry-subtle": "theme-module__4jKnka__berry-subtle",
  "dark": "theme-module__4jKnka__dark",
  "dark-scheme": "theme-module__4jKnka__dark-scheme",
  "info-strong": "theme-module__4jKnka__info-strong",
  "info-subtle": "theme-module__4jKnka__info-subtle",
  "inverse": "theme-module__4jKnka__inverse",
  "light-scheme": "theme-module__4jKnka__light-scheme",
  "moss-moderate": "theme-module__4jKnka__moss-moderate",
  "moss-standard": "theme-module__4jKnka__moss-standard",
  "moss-strong": "theme-module__4jKnka__moss-strong",
  "moss-subtle": "theme-module__4jKnka__moss-subtle",
  "smoke-moderate": "theme-module__4jKnka__smoke-moderate",
  "smoke-standard": "theme-module__4jKnka__smoke-standard",
  "smoke-strong": "theme-module__4jKnka__smoke-strong",
  "smoke-subtle": "theme-module__4jKnka__smoke-subtle",
  "standard": "theme-module__4jKnka__standard",
  "subtle": "theme-module__4jKnka__subtle",
});
